module.exports = __webpack_public_path__ + "static/flowers-1cb21a6b8d4c796eeab8d83955ab9d68.jpg";